import CollectivePurchasingService from '../collective-purchasing-service';
import Service from '@/service/index.js';
import LocationService from '@/components/location-select/service';
import Pagination from '@/components/pagination/index.vue';
import { changeSkin } from '@/utils/common.js';
import { mapGetters } from 'vuex';
// import AreaCodeHolder from '@/common/areaCodeHolder.js';
export default {
  components: {
    Pagination
  },
  data () {
    return {
      purchaseListStatus: [],
      purchaseProjectType: [],
      qualificationReview: [],
      purchaseBudgetArr: [{ code: '0-50', name: '0-50万' }, { code: '50-100', name: '50-100万' }, { code: '100-200', name: '100-200万' },
      { code: '200-500', name: '200-500万' }, { code: '500-1000', name: '500-1000万' }, { code: '1000', name: '1000万及以上' }],
      cityArr: [],
      query: {
        purchaseBudget: '',
        projectType: '',
        status: '',
        city: '',
        pageNum: 1,
        pageSize: 10,
        name: '',
        projectName: ''
      },
      projectList: [],
      total: 0
    };
  },
  computed: {
    ...mapGetters(['getTenantParams'])
  },
  created () {
    this.getPurchaseListStatus();
    this.getPurchaseProjectType();
    this.getQualificationReview();
    this.getCityList();
  },
  methods: {
    changeSkin,
    getPurchaseListStatus () {
      CollectivePurchasingService.getPurchaseListStatus('purchaseStatus').then(res => {
        if (res && (res.code === '0')) {
          this.purchaseListStatus = res && res.data && res.data.purchaseList;
          this.getPurchaseList();
        }
      });
    },
    getPurchaseProjectType () {
      Service.getSelectList('PURCHASE_PROJECT_TYPE').then(res => {
        if (res && res.code === '0') {
          this.purchaseProjectType = res.data;
        }
      });
    },
    getQualificationReview () {
      Service.getSelectList('QUALIFICATION_REVIEW').then(res => {
        if (res && res.code === '0') {
          this.qualificationReview = res.data;
        }
      });
    },
    getCityList () {
      let areaCode = localStorage.areaCode || this.getTenantParams.areaCode;
      let level = localStorage.level ? Number(localStorage.level) + 1 : 2;
      // const length = AreaCodeHolder.getInstance().areaCode.length;
      LocationService.getLocationList(areaCode, level).then(res => {
        if (res && res.code === '0') {
          this.cityArr = res.data;
          this.cityArr = this.cityArr.filter(item => item.areaName !== '白');
        }
      });
    },
    changeFormValue (key, value) {
      if (key === 'projectName') {
        this.query.purchaseBudget = '';
        this.query.projectType = '';
        this.query.status = '';
        this.query.city = '';
        this.query.name = '';
        this.query.pageNum = 1;
        this.query.pageSize = 10;
        this.getPurchaseList();
        return;
      }
      // if (key === 'status') {
      //   this.query.status = [value];
      // } else {
      //   this.query[key] = value;
      // }
      this.query[key] = value;

      this.query.projectName = '';
      this.getPurchaseList();
    },
    getPurchaseList (page) {
      if (page) {
        this.query.pageNum = page.pageNo;
        this.query.pageSize = page.pageSize;
      }
      const obj = {};
      Object.keys(this.query).forEach(item => {
        // if (item === 'status' && (this.query[item][0] === 'all' || !this.query[item].length)) {
        //   obj.status = this.purchaseListStatus.map(item => item.code);
        // } else if (this.query[item] && (this.query[item] !== 'all')) {
        //   obj[item] = this.query[item];
        // }
        if (this.query[item] && (this.query[item] !== 'all')) {
          obj[item] = this.query[item];
        }
      });
      CollectivePurchasingService.getPurchaseList(obj).then(res => {
        if (res && res.code === '0') {
          this.total = res && res.data.total;
          this.projectList = res && res.data.list;
          this.projectList.forEach(item => {
            // 已成交的状态
            if (Number(item.signStatus) === 0) {
              if (70 <= item.status && item.status <= 90 || item.status === 96) {

                item.status = 70;
              } else if ([51, 92, 93, 94, 95].includes(item.status)) {
                item.status = 95;// 已结束的状态
              }
            } else {
              item.status = 50;
            }
          });
        }
      });
    },
    resetQuery () {
      this.query = {
        purchaseBudget: '',
        projectType: '',
        status: '',
        city: '',
        pageNum: 1,
        pageSize: 10
      };
      this.getPurchaseList();
    },
    getProjectType (type) {
      if (type === 1) {
        return require('@/assets/images/common/engineering1.jpg');
      } else if (type === 2) {
        return require('@/assets/images/common/goods1.jpg');
      } else {
        return require('@/assets/images/common/service1.jpg');
      }
    },
    getProjectStatusStyle (status) {
      if (status === 42) {
        return 'background: #F7B500';
      } else if (status === 50) {
        return 'background: #00B58D';
      } else if (status === 51) {
        return 'background: #0DCE03';
      } else if (status === 60) {
        return 'background: #FA5741';
      } else if ([70, 95, 97].includes(status)) {
        return 'background: #383838';
      }
    },
    goToDetail (id, status) {
      this.$router.push('/collective-purchasing/detail?id=' + id + '&status=' + status);
    }
  }
};
